import { permissionsCover } from '@/utils/accessDomains'

const roleList = (view) => view?.roles ?? []

export const getters = {
  view: state => state.views[state.orgId],
  viewFor: state => orgId => state.views[Number(orgId)],
  loaded: state => !!state.views[state.orgId],
  domains: (_s, getters) => kind => getters.view?.domains?.[kind] ?? [],
  roles: (_s, getters) => kind => roleList(getters.view).filter(r => !kind || r.kind === kind),
  role: (_s, getters) => id => roleList(getters.view).find(r => r.role_id === Number(id)),
  myOrgRoleId: (_s, getters) => getters.view?.my_org_role_id ?? null,
  myProjectRoleId: (_s, getters) => projectId => getters.view?.my_project_roles?.[String(projectId)],
  isOwner: (_s, getters) => !!getters.view?.is_owner,
  isSuperUser: (_s, getters) => !!getters.view?.is_super_user,
  joinGrants: (_s, getters) => getters.view?.my_join_grants ?? [],
  ownerMemberId: (_s, getters) => getters.view?.owner_member_id ?? null,
  defaultJoinRole: (_s, getters) => getters.roles('project').find(r => r.is_default_join),
  defaultJoinRoleId: (_s, getters) => getters.defaultJoinRole?.role_id ?? null,
  defaultJoinRoleName: (_s, getters) => getters.defaultJoinRole?.name ?? 'Viewer',
  roleChoices: (_s, getters) => kind => getters.roles(kind).map(r => ({ value: r.role_id, label: r.name })),
  // Whether the caller may assign or invite `role`: the Owner and super users may grant anything, anyone else at
  // most their own role's permissions (org role for org roles, their role in `projectId` for project roles).
  grantable: (_s, getters) => (role, projectId) => {
    if (getters.isOwner || getters.isSuperUser) return true
    const mineId = role.kind === 'project' ? getters.myProjectRoleId(projectId) : getters.myOrgRoleId
    return permissionsCover(getters.role(mineId)?.permissions, role.permissions)
  },
  seededRoleId: (_s, getters) => templateKey =>
    roleList(getters.view).find(r => r.template_key === templateKey)?.role_id ?? null,
}
